module.exports = __webpack_public_path__ + "img/26e0c4c.png";